class StoragePreBidNoteComponentCtrl implements ng.IController {}

angular.module('app').component('pkpStoragePreBidNote', {
    controller: StoragePreBidNoteComponentCtrl,
    template: require('app/storage-offer-bid/storage-pre-bid-note.component.html'),
    bindings: {}
});
